import { capitalizeWords } from '@doveit/hammer';

export class UserFilterParam {
  constructor(
    public email: string,
    public shortName?: string,
    public id?: number,
  ) {}

  static fromQueryParam(str: string): UserFilterParam {
    const [email, name, id] = str.split('|');
    const formattedName = name ? capitalizeWords(name.replaceAll('_', ' ')) : undefined;
    return new UserFilterParam(email, formattedName, id ? Number(id) : undefined);
  }

  toString(): string {
    const base = `${this.email}|${this.shortName?.toLowerCase().replaceAll(' ', '_')}`;
    if (this.id !== undefined && this.id !== null) {
      return `${base}|${this.id}`;
    }
    return base;
  }
}
